import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-service-object-new-act',
  templateUrl: './service-object-new-act.component.html',
  styleUrls: ['./service-object-new-act.component.css']
})
export class ServiceObjectNewActComponent implements OnInit {
    serviceObjectKeyno;

    public setting?: Setting;

    public itemsListNewActs: Item[] = [];

    public creating = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.serviceObjectKeyno = this.stateService.getStateParams()['serviceobject_keyno'];
    }

    private async loadSetting() {
        if (!!this.serviceObjectKeyno) {
            this.setting = (await this.datatask.Post(1748, { serviceobject_keyno: this.serviceObjectKeyno }))[0];
        }
    }

    private async loadNewActs() {
        if (!this.setting) return;

        return this.itemsListNewActs = await this.datatask.Post(1749, this.setting);
    }

    public async createChanges() {
        if (!!this.setting && !!this.itemsListNewActs) {
            try {
                this.creating = true;
                
                const selectedItems = (this.itemsListNewActs ?? []).filter((row) => row['item_is_selected'] === '1').map((row) => ({
                    serviceobjecttypeint_keyno: row['item_id'],
                    nextdate: row['nextdate']
                }));

                const response = (await this.datatask.Post(1750, {
                    serviceobject_keyno: this.setting.serviceobject_keyno,
                    records: selectedItems
                }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.creating = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'start_date':
                this.loadNewActs();
                break;
            default:
                break;
        }
    }

    toggleChosen(item: any): void {
        item = item?.item ? item.item : item;

        if (item.item_id === '0' || item.item_id === '-1') return;

        if (item.item_is_selected === '0') {
            item.item_is_selected = '1';
        } else if (item.item_is_selected === '1') {
            item.item_is_selected = '0';
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadNewActs();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    serviceobject_keyno: string;
    start_date: string;
    page_heading: string;
    serviceobjecttype_keyno: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('serviceObjectNewAct', {
//        templateUrl: 'views/components/views/serviceObjectNewAct/serviceObjectNewAct.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'serviceObjectNewActService', function ($stateParams, stateService, utilityService, modalService, translateService, serviceObjectNewActService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let serviceObjectKeyno = $stateParams.serviceobject_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                setting: {},
//                itemsListNewActs: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await serviceObjectNewActService.getSettings({ serviceobject_keyno: serviceObjectKeyno }))[0];
//            }

//            async function loadNewActs() {
//                if (utilityService.validateParmsValue(vm.model.setting.start_date) !== true) return;

//                return vm.model.itemsListNewActs = await serviceObjectNewActService.listNewActs(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region TOGGLE FUNCTIONS

//            vm.toggleChosen = function (item) {
//                item = item?.item ? item.item : item;

//                if (item.item_id === '0' || item.item_id === '-1') return;

//                if (item.item_is_selected === '0') {
//                    item.item_is_selected = '1';
//                } else if (item.item_is_selected === '1') {
//                    item.item_is_selected = '0';
//                }
//            };

//            vm.setMarkedAs = function () {
//                vm.model.lockedSave = true;
//                let selectedItems = [];

//                vm.model.itemsListNewActs.forEach((item) => {
//                    if (item.item_id === '0' || item.item_id === '-1') return;
//                    if (item.item_is_selected === '0') return;

//                    selectedItems.push({
//                        serviceobjecttypeint_keyno: item.item_id,
//                        nextdate: item.nextdate
//                    });
//                });

//                serviceObjectNewActService.createObj({
//                    serviceobject_keyno: vm.model.setting.serviceobject_keyno,
//                    records: selectedItems
//                }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion TOGGLE FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'start_date':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.start_date) !== true) return;

//                        vm.model.setting.start_date = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.start_date) !== true) return;

//                        loadNewActs();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadNewActs();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
